import styles from './FJAvatarInfo.module.less';
import PropTypes from 'prop-types';
import FJCommunityUtil from '../../../../../util/FJCommunityUtil.js';
const FJAvatarInfo = props => {
    const { info } = props;
    const { avatar, username, userKey } = info;

    if (!avatar) {
        return null;
    }

    const _onUserClick = () => {
        FJCommunityUtil.openUserPage(userKey);
    };

    return (
        <div className={styles.box}>
            <img src={avatar} alt='' onClick={_onUserClick} />
            <div className={styles.name} onClick={_onUserClick}>
                {username}
            </div>
        </div>
    );
};

FJAvatarInfo.propTypes = {
    info: PropTypes.object.isRequired,
};
export default FJAvatarInfo;
